
<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div v-if="submission != undefined" class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <span v-if="submission != undefined">Date Received: {{submission.dateInserted}}</span>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body" v-if="submission != undefined">
              <div class="imageEditor">
                <div style="height:300px;">
                  <img 
                    v-if="submission.userImage != ''"
                    :style="imageStyle"
                    :src="'https://app.brighton.com/brighton-your-day/tmp/900_'+submission.userImage+'?'+Math.random()"
                    alt
                  />
                  <span v-else style="color:red">No Image</span>
                </div>
                <div class="pane"  v-if="submission.userImage != ''">
                  <button @click="paneImage(-90)">Rotate Left</button>
                  <button @click="paneImage(90)">Rotate Right</button>
                </div>
              </div>
              <table class="info">
                <tr>
                  <td>First Name:</td>
                  <td>
                    <input type="text" v-model="submission.firstName" />
                  </td>
                </tr>
                <tr>
                  <td>Last Name:</td>
                  <td>
                    <input type="text" v-model="submission.lastName" />
                  </td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td>
                    <input type="text" v-model="submission.email" />
                  </td>
                </tr>
                <tr>
                  <td>Phone:</td>
                  <td>
                    <input type="text" v-model="submission.phone" />
                  </td>
                </tr>
                <tr>
                  <td>City:</td>
                  <td>
                    <input type="text" v-model="submission.city" />
                  </td>
                </tr>
                <tr>
                  <td>Country:</td>
                  <td>
                    <select v-model="submission.country">
                      <option
                        v-for="country in countries"
                        v-bind:value="country.code"
                      >{{country.name}}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>Picture Location</td>
                  <td>
                    <textarea name v-model="submission.pictureLocation" id cols="30" rows="10"></textarea>
                  </td>
                </tr>
                <tr>
                  <td>Approve:</td>
                  <td>
                    <select v-model="submission.approved">
                      <option v-bind:value="1">Approved</option>
                      <option v-bind:value="0">Pending</option>
                      <option v-bind:value="-1">Rejected</option>
                    </select>
                  </td>
                </tr>
              </table>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('cancel')">Cancel</button>
              <button class="modal-default-button" @click="save">Save</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
const axios = require("axios");
import countries from "../../countries.json";
export default {
  name: "adminPopup",
  data() {
    return {
      angle: 0,
      countries: null
    };
  },
  props: { submission: Object },
  computed: {
    imageStyle: function() {
      //
      console.log(this.angle);
      return { transform: "rotate(" + this.angle + "deg)" };
    }
  },
  methods: {
    async save() {
      var formData = new FormData();
      formData.append("id", this.submission.id);
      formData.append("approved", this.submission.approved);
      formData.append("angle", this.angle);
      formData.append("firstName", this.submission.firstName);
      formData.append("lastName", this.submission.lastName);
      formData.append("emailAdd", this.submission.email);
      formData.append("phone", this.submission.phone);
      formData.append("pictureLocation", this.submission.pictureLocation);
      formData.append("subscriberKey", this.submission.subscriberKey);
      formData.append("city", this.submission.city);
      formData.append("country", this.submission.country);

      let returnedData = await axios({
        method: "POST",
        url: `https://app.brighton.com/brighton-your-day/api/admin/edit/${this.submission.id}`,
        responseType: "json",
        data: formData,
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      });
      this.$emit("save");
    },
    paneImage(degree) {
      this.angle += degree;
      this.angle %= 360;
    }
  },
  mounted() {
    this.countries = countries;
  }
};
</script>
<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;

  .imageEditor {
    display: block;
    /* height:900px;
    width:900px; */
    .pane {
      text-align: center;
      margin: 20px 0;
    }
    img {
      margin: 0 auto;
      display: block;
      max-width: 300px;
      max-height: 300px;
      /* height:300px; */
      margin-top: 100px;
    }
  }
}
.modal-footer {
  margin-bottom: 10px;
}
.modal-default-button {
  /* float: right; */
  margin-right: 10px;
  padding: 5px;
  min-width: 100px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>